// extracted by mini-css-extract-plugin
module.exports = {"guide":"Goods_guide__2ux8T","intro":"Goods_intro__1hti4","intro_1":"Goods_intro_1__3Dfyy"};